import { Button } from "components/button";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { isValidFilter } from "./utils";
import { defaultFilterValues } from "./constants";

export const ActiveFilterClear = ({ filterName }: { filterName: string }) => {
  const { setValue, getValues } = useFormContext();
  const { t } = useTranslation(["general"]);
  const filter = useWatch({ name: `filters.${filterName}` });
  const isFilterActive = isValidFilter(filter, new Date());

  if (!isFilterActive) return null;

  const resetFilter = () => {
    if (filterName in defaultFilterValues) {
      setValue("filters", {
        ...getValues("filters"),
        [filterName]:
          defaultFilterValues[filterName as keyof typeof defaultFilterValues],
      });
    }
  };

  return (
    <Button
      variant="link"
      size="small"
      label={t("general:buttons.clear")}
      onClick={resetFilter}
      className="p-0 text-xs text-secondary-400 hover:text-secondary-600"
      aria-label={t("general:buttons.clear")}
    />
  );
};
